var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "2xl" },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("ModalContent", { staticClass: "relative mb-0" }, [
              _c(
                "span",
                {
                  staticClass:
                    "cursor-pointer flex items-center justify-center absolute customPosition",
                  on: {
                    click: _vm.closeModal,
                    mouseover: function ($event) {
                      _vm.isHovered = true
                    },
                    mouseout: function ($event) {
                      _vm.isHovered = false
                    },
                  },
                },
                [
                  !_vm.isHovered
                    ? _c("CrossIcon", { staticClass: "h-4 w-4" })
                    : _vm._e(),
                  _vm.isHovered
                    ? _c("CrossIconHover", { staticClass: "h-4 w-4" })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "flex xl:flex-wrap flex-col xl:flex-row h-auto",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col justify-flex-start items-center",
                      class: _vm.isTimeAddedAlreadyStyle(
                        _vm.requestHoursSlot,
                        _vm.timeAggregate,
                        _vm.requestedHours
                      ),
                    },
                    [
                      !_vm.hasRunningTimer
                        ? _c(
                            "nav",
                            {
                              staticClass:
                                "flex flex-row borderBottom gap-6 w-fit",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "text-gray-new text-lg py-3 px-1 block hover:text-blue-500 focus:outline-none",
                                  class: _vm.timerTrackerClasses,
                                  on: { click: _vm.showTimerSlot },
                                },
                                [_vm._v(" Timer ")]
                              ),
                              !_vm.timerRunning && !_vm.timerRecorded
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "flex flex-col sm:flex-row",
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "text-gray-new py-3 text-lg px-1 block hover:text-blue-500 focus:outline-none",
                                          class: _vm.rangeTrackerClasses,
                                          on: { click: _vm.showRangeSlot },
                                        },
                                        [_vm._v(" Manual ")]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass: "flex flex-col sm:flex-row",
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "text-gray-new py-3 text-lg px-1 block hover:text-blue-500 focus:outline-none",
                                          class: _vm.rangeTrackerClasses,
                                        },
                                        [_vm._v(" Manual ")]
                                      ),
                                    ]
                                  ),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "text-gray-new py-3 text-lg px-1 block hover:text-blue-500 focus:outline-none",
                                  class: _vm.requestHoursClasses,
                                  on: { click: _vm.showRequestHoursSlot },
                                },
                                [_vm._v(" Request Hours ")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.hasRunningTimer
                        ? _c(
                            "div",
                            { staticClass: "h-full flex items-center" },
                            [
                              _c("p", [
                                _vm._v(" A timer is already running for task "),
                                _c("span", { staticClass: "italic" }, [
                                  _vm._v(
                                    "'" +
                                      _vm._s(_vm.showTrackingModes.title) +
                                      "'"
                                  ),
                                ]),
                                _vm.showTrackingModes.project
                                  ? _c("span", [
                                      _vm._v("for project "),
                                      _c("span", { staticClass: "italic" }, [
                                        _vm._v(
                                          "'" +
                                            _vm._s(
                                              _vm.showTrackingModes.project
                                            ) +
                                            "'"
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(". Please attend to that first. "),
                              ]),
                              _c("p", [
                                _vm._v(
                                  " You can't track two tasks at the same time. Close timer for \"" +
                                    _vm._s(_vm.showTrackingModes.title) +
                                    '" before you start a new session. '
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      !_vm.hasRunningTimer
                        ? _c("div", { staticClass: "w-full" }, [
                            _vm.timerTracker
                              ? _c("div", [
                                  _c(
                                    "form",
                                    {
                                      staticClass:
                                        "px-2.5 py-4 pt-9 flex flex-col justify-between customHeightTimeTracking",
                                      on: {
                                        submit: function ($event) {
                                          $event.preventDefault()
                                        },
                                      },
                                    },
                                    [
                                      _c("div", [
                                        _vm.timerRecorded
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-lg py-3 px-1 block font-semibold text-default-black text-center",
                                              },
                                              [
                                                _vm._v(
                                                  " Timer stopped. Your total time tracked is "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mb-1.5 flex items-center justify-center",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "timerLabel",
                                                attrs: { id: "timerLabel" },
                                              },
                                              [_vm._v("00:00:00")]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mb-4 items-center justify-center text-center cursor-pointer",
                                          },
                                          [
                                            !_vm.timerRecorded
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass: "customFocus",
                                                    attrs: {
                                                      type: "button",
                                                      id: "timerbtn",
                                                      fullWidth: "",
                                                    },
                                                    on: {
                                                      click: _vm.startStopTimer,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.buttonStartTimer
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c("div", { staticClass: "mb-6" }, [
                                          _vm.timerRecorded
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "cursor-pointer flex items-center justify-center",
                                                  on: {
                                                    click: _vm.discardTimer,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-primary-black ml-1",
                                                    },
                                                    [_vm._v("Discard")]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                        _c("div", { staticClass: "mb-2" }, [
                                          _c(
                                            "label",
                                            { staticClass: "customFormLabel" },
                                            [_vm._v("Add Notes:")]
                                          ),
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.notes,
                                                expression: "notes",
                                              },
                                            ],
                                            staticClass:
                                              "block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500",
                                            attrs: {
                                              id: "message",
                                              rows: "1",
                                              placeholder: "Notes",
                                            },
                                            domProps: { value: _vm.notes },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.notes = $event.target.value
                                              },
                                            },
                                          }),
                                        ]),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-row gap-4 mt-5 xl:mt-0",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "outlineTimeButton buttonHover",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.processing,
                                              },
                                              on: { click: _vm.closeModal },
                                            },
                                            [_vm._v(" Cancel ")]
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "blackTimeButton buttonHover",
                                              attrs: {
                                                type: "button",
                                                disabled:
                                                  !_vm.canSave ||
                                                  _vm.processing,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.saveTimeTrack(
                                                    $event
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.id
                                                      ? "Update"
                                                      : _vm.buttonText
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm.rangeTracker
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "w-full px-2.5 py-4 pt-9 flex flex-col justify-between customHeightTimeTracking",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "w-full space-y-3" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "w-full" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "customFormLabel",
                                              },
                                              [_vm._v("Date:")]
                                            ),
                                            _c("FormDatepicker", {
                                              attrs: { name: "today date" },
                                              model: {
                                                value: _vm.tracked_date,
                                                callback: function ($$v) {
                                                  _vm.tracked_date = $$v
                                                },
                                                expression: "tracked_date",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex w-full justify-between space-x-3 maxWidth",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "w-1/2" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "customFormLabel",
                                                  },
                                                  [_vm._v("Start Time:")]
                                                ),
                                                _c("NewTimePicker", {
                                                  attrs: {
                                                    format: "HH:mm:ss",
                                                    "auto-scroll": "",
                                                    "advanced-keyboard": "",
                                                    "input-width": "100%",
                                                    "input-class":
                                                      "appearance-none border text-sm rounded-lg py-2.5 px-3 leading-tight focus:outline-none focus:shadow-outline scrollbar",
                                                  },
                                                  model: {
                                                    value: _vm.start_time,
                                                    callback: function ($$v) {
                                                      _vm.start_time = $$v
                                                    },
                                                    expression: "start_time",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "w-1/2" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "customFormLabel",
                                                  },
                                                  [_vm._v("End Time:")]
                                                ),
                                                _c("NewTimePicker", {
                                                  attrs: {
                                                    format: "HH:mm:ss",
                                                    "auto-scroll": "",
                                                    "advanced-keyboard": "",
                                                    "input-width": "100%",
                                                    "hide-disabled-items": "",
                                                    "hour-range":
                                                      _vm.end_timeHourRange,
                                                    "minute-range":
                                                      _vm.end_timeMinuteRange,
                                                    "second-range":
                                                      _vm.end_timeSecondRange,
                                                    "input-class":
                                                      "appearance-none border text-sm rounded-lg py-2.5 px-3 leading-tight focus:outline-none focus:shadow-outline scrollbar",
                                                  },
                                                  model: {
                                                    value: _vm.end_time,
                                                    callback: function ($$v) {
                                                      _vm.end_time = $$v
                                                    },
                                                    expression: "end_time",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm.end_timeError
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-sm text-red-400 italic",
                                              },
                                              [
                                                _vm._v(
                                                  " *End time must be greater than start time "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c("div", { staticClass: "w-full" }, [
                                          _c(
                                            "label",
                                            { staticClass: "customFormLabel" },
                                            [_vm._v("Add Notes:")]
                                          ),
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.notes,
                                                expression: "notes",
                                              },
                                            ],
                                            staticClass:
                                              "block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500",
                                            attrs: {
                                              id: "message",
                                              rows: "1",
                                              placeholder: "Notes",
                                            },
                                            domProps: { value: _vm.notes },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.notes = $event.target.value
                                              },
                                            },
                                          }),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-row gap-4 mt-5 xl:mt-0",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "outlineTimeButton buttonHover",
                                            attrs: {
                                              type: "button",
                                              disabled: _vm.processing,
                                            },
                                            on: { click: _vm.closeModal },
                                          },
                                          [_vm._v(" Cancel ")]
                                        ),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "blackTimeButton buttonHover",
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                !_vm.canSave || _vm.processing,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.saveTimeTrack($event)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.id
                                                    ? "Update"
                                                    : _vm.buttonText
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.manualTracker
                              ? _c("div", { staticClass: "w-full" }, [
                                  _c(
                                    "form",
                                    {
                                      staticClass:
                                        "px-2.5 py-4 pt-9 flex flex-col justify-between customHeightTimeTracking",
                                      on: {
                                        submit: function ($event) {
                                          $event.preventDefault()
                                        },
                                      },
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "customFormLabel",
                                              },
                                              [_vm._v("Date:")]
                                            ),
                                            _c("FormDatepicker", {
                                              attrs: { name: "today date" },
                                              model: {
                                                value: _vm.tracked_date,
                                                callback: function ($$v) {
                                                  _vm.tracked_date = $$v
                                                },
                                                expression: "tracked_date",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "mb-4 flex flex-col" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "customFormLabel",
                                              },
                                              [_vm._v("Time:")]
                                            ),
                                            _c("NewTimePicker", {
                                              attrs: {
                                                format: "HH:mm:ss",
                                                "auto-scroll": "",
                                                "advanced-keyboard": "",
                                                "input-class":
                                                  "appearance-none border text-sm rounded-md w-full py-2.5 px-3 leading-tight focus:outline-none focus:shadow-outline scrollbar",
                                              },
                                              model: {
                                                value: _vm.manualTimeInput,
                                                callback: function ($$v) {
                                                  _vm.manualTimeInput = $$v
                                                },
                                                expression: "manualTimeInput",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("div", { staticClass: "mb-4" }, [
                                          _c(
                                            "label",
                                            { staticClass: "customFormLabel" },
                                            [_vm._v("Add Notes:")]
                                          ),
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.notes,
                                                expression: "notes",
                                              },
                                            ],
                                            staticClass:
                                              "block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500",
                                            attrs: {
                                              id: "message",
                                              rows: "1",
                                              placeholder: "Notes",
                                            },
                                            domProps: { value: _vm.notes },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.notes = $event.target.value
                                              },
                                            },
                                          }),
                                        ]),
                                        _vm.id
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mb-2 text-blue-600 font-semibold text-sm",
                                              },
                                              [
                                                _vm._v(
                                                  " Editing time entry - changes will update the existing record "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-row gap-4 mt-5 xl:mt-0",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "outlineTimeButton buttonHover",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.processing,
                                              },
                                              on: { click: _vm.closeModal },
                                            },
                                            [_vm._v(" Cancel ")]
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "blackTimeButton buttonHover",
                                              attrs: {
                                                type: "button",
                                                disabled:
                                                  !_vm.canSave ||
                                                  _vm.processing,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.saveTimeTrack(
                                                    $event
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.id
                                                      ? "Update"
                                                      : _vm.buttonText
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm.requestHoursSlot
                              ? _c("div", [
                                  _c(
                                    "form",
                                    {
                                      staticClass:
                                        "sm:px-6 py-4 pt-9 flex flex-col justify-between customHeightTimeTracking",
                                      on: {
                                        submit: function ($event) {
                                          $event.preventDefault()
                                        },
                                      },
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "mb-4 flex flex-col" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "customFormLabel",
                                              },
                                              [_vm._v("Select time:")]
                                            ),
                                            _c("NewTimePicker", {
                                              attrs: {
                                                format: "HH:mm:ss",
                                                "auto-scroll": "",
                                                "input-width": "100%",
                                                "advanced-keyboard": "",
                                                "input-class":
                                                  "appearance-none border text-sm rounded-lg w-full py-2.5 px-3 leading-tight focus:outline-none focus:shadow-outline scrollbar",
                                              },
                                              model: {
                                                value: _vm.requestTimeInput,
                                                callback: function ($$v) {
                                                  _vm.requestTimeInput = $$v
                                                },
                                                expression: "requestTimeInput",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("div", { staticClass: "mb-4" }, [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "customFormLabel mb-2",
                                            },
                                            [_vm._v("Reason:")]
                                          ),
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.reason,
                                                expression: "reason",
                                              },
                                            ],
                                            staticClass:
                                              "block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500",
                                            attrs: {
                                              id: "message",
                                              rows: "1",
                                              placeholder: "Reason for request",
                                            },
                                            domProps: { value: _vm.reason },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.reason = $event.target.value
                                              },
                                            },
                                          }),
                                        ]),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-row gap-4 mt-5 xl:mt-0",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "outlineTimeButton buttonHover",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.processing,
                                              },
                                              on: { click: _vm.closeModal },
                                            },
                                            [_vm._v(" Cancel ")]
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "blackTimeButton buttonHover",
                                              attrs: {
                                                type: "button",
                                                disabled:
                                                  !_vm.canSave ||
                                                  _vm.processing,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.sendRequest($event)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.id
                                                      ? "Update"
                                                      : _vm.buttonText
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _c("div", { staticClass: "w-auto" }, [
                    _vm.requestHoursSlot && _vm.requestedHours.length
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-col p-4 h-full sm:rounded-lg customOverflow",
                          },
                          [
                            _c("div", { staticClass: "flex-grow" }, [
                              _c("p", { staticClass: "headingText" }, [
                                _vm._v(
                                  "Total Hours Requested for " +
                                    _vm._s(_vm.getTitle)
                                ),
                              ]),
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "relative w-full text-sm text-bold text-left dark:text-gray-400",
                                },
                                [
                                  _c(
                                    "tbody",
                                    { staticClass: "divide-y" },
                                    _vm._l(_vm.requestedHours, function (time) {
                                      return _c(
                                        "tr",
                                        {
                                          key: time.id,
                                          staticClass:
                                            "bg-white text-black border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600",
                                        },
                                        [
                                          _c(
                                            "td",
                                            { staticClass: "p-4" },
                                            [
                                              _c("StatusBadge", {
                                                attrs: { status: time.status },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("td", { staticClass: "p-4" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.convertSecondsToReadable(
                                                    time.hours
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                          _c("td", { staticClass: "p-4" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.convertDateString(
                                                    time.created_at
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                          _c("td", { staticClass: "p-4" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex w-full items-center",
                                              },
                                              [
                                                time.status.toLowerCase() ===
                                                "approved"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "opacity-25 cursor-not-allowed mr-2 flex",
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg",
                                                              width: "25",
                                                              height: "24",
                                                              viewBox:
                                                                "0 0 25 24",
                                                              fill: "none",
                                                            },
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M13.6154 6.82679L6.34208 14.1032C6.01896 14.4264 5.78278 14.8272 5.65226 15.2654L4.54602 19.0247C4.46949 19.2849 4.53992 19.5634 4.72958 19.753C4.91926 19.9427 5.19771 20.0131 5.45481 19.9397C5.45483 19.9397 5.45485 19.9397 5.45487 19.9397L9.21407 18.8335L13.6154 6.82679ZM13.6154 6.82679L17.6558 10.8672L10.3762 18.1436C10.0531 18.4668 9.65229 18.7029 9.21412 18.8334L13.6154 6.82679ZM19.8856 5.83135L19.8856 5.83136C20.6608 6.60651 20.6608 7.86224 19.8856 8.63739L18.3842 10.1388L14.3438 6.09844L15.8373 4.60491V4.60803L15.8483 4.59699C16.6235 3.82184 17.8792 3.82184 18.6543 4.59697L18.6544 4.59699L19.8856 5.83135Z",
                                                                fill: "#010A11",
                                                                stroke:
                                                                  "#333333",
                                                                "stroke-width":
                                                                  "0.03125",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "mr-2 cursor-pointer flex",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.setToEditRequestedHours(
                                                              time
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_c("TimeTrackingEdit")],
                                                      1
                                                    ),
                                                time.status.toLowerCase() ===
                                                "approved"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "opacity-25 cursor-not-allowed mr-2 flex",
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg",
                                                              width: "25",
                                                              height: "24",
                                                              viewBox:
                                                                "0 0 25 24",
                                                              fill: "none",
                                                            },
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M9.73896 4.56015L9.739 4.56006C9.90509 4.22481 10.2465 4.01562 10.6188 4.01562H14.3813C14.7535 4.01562 15.0949 4.22481 15.261 4.56006L15.261 4.56015L15.486 5.00703L15.4904 5.01562H15.5H18.5C19.0445 5.01562 19.4844 5.4555 19.4844 6C19.4844 6.5445 19.0445 6.98438 18.5 6.98438H6.5C5.9555 6.98438 5.51562 6.5445 5.51562 6C5.51562 5.4555 5.9555 5.01562 6.5 5.01562H9.5H9.50963L9.51396 5.00703L9.73896 4.56015ZM6.51562 8.01562H18.4844V18C18.4844 19.0945 17.5945 19.9844 16.5 19.9844H8.5C7.4055 19.9844 6.51562 19.0945 6.51562 18V8.01562ZM9.5 9.98438C9.21637 9.98438 8.98438 10.2164 8.98438 10.5V17.5C8.98438 17.7836 9.21637 18.0156 9.5 18.0156C9.78363 18.0156 10.0156 17.7836 10.0156 17.5V10.5C10.0156 10.2164 9.78363 9.98438 9.5 9.98438ZM12.5 9.98438C12.2164 9.98438 11.9844 10.2164 11.9844 10.5V17.5C11.9844 17.7836 12.2164 18.0156 12.5 18.0156C12.7836 18.0156 13.0156 17.7836 13.0156 17.5V10.5C13.0156 10.2164 12.7836 9.98438 12.5 9.98438ZM15.5 9.98438C15.2164 9.98438 14.9844 10.2164 14.9844 10.5V17.5C14.9844 17.7836 15.2164 18.0156 15.5 18.0156C15.7836 18.0156 16.0156 17.7836 16.0156 17.5V10.5C16.0156 10.2164 15.7836 9.98438 15.5 9.98438Z",
                                                                fill: "#010A11",
                                                                stroke:
                                                                  "#333333",
                                                                "stroke-width":
                                                                  "0.03125",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "mr-2 cursor-pointer flex",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteRequestedHours(
                                                              time.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "TimeTrackingDelete"
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                time.status.toLowerCase() ===
                                                "rejected"
                                                  ? _c("span", {
                                                      staticClass:
                                                        "cursor-pointer flex",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "openRequestedHoursDeclineReasonModal",
                                                            time
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "textBlue" }, [
                                _vm._v(
                                  " Total Hours Requested " +
                                    _vm._s(
                                      _vm.convertSecondsToReadable(
                                        _vm.hoursAggregate
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.trackedTimes.length && !_vm.requestHoursSlot
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-col p-4 h-auto sm:rounded-lg customOverflow",
                          },
                          [
                            _c("div", { staticClass: "flex-grow" }, [
                              _c("p", { staticClass: "headingText" }, [
                                _vm._v(
                                  "Hours tracked for " + _vm._s(_vm.getTitle)
                                ),
                              ]),
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "relative w-full text-sm text-bold text-left dark:text-gray-400",
                                },
                                [
                                  _c(
                                    "tbody",
                                    { staticClass: "divide-y" },
                                    _vm._l(_vm.trackedTimes, function (time) {
                                      return _c(
                                        "tr",
                                        {
                                          key: time.id,
                                          staticClass:
                                            "bg-white text-black border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600",
                                        },
                                        [
                                          _c(
                                            "td",
                                            { staticClass: "p-4" },
                                            [
                                              _c("StatusBadge", {
                                                attrs: { status: time.status },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("td", { staticClass: "p-4" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.convertSecondsToReadable(
                                                    time.time
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                          _c("td", { staticClass: "p-4" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.convertDateString(
                                                    time.tracked_date
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                          _c("td", { staticClass: "p-4" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex w-full items-center",
                                              },
                                              [
                                                time.status.toLowerCase() ===
                                                "approved"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "opacity-25 cursor-not-allowed mr-2 flex",
                                                      },
                                                      [_c("TimeTrackingEdit")],
                                                      1
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "mr-2 cursor-pointer flex",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.setToEdit(
                                                              time
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_c("TimeTrackingEdit")],
                                                      1
                                                    ),
                                                time.status.toLowerCase() ===
                                                "approved"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "opacity-25 cursor-not-allowed mr-2 flex",
                                                      },
                                                      [
                                                        _c(
                                                          "TimeTrackingDelete"
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "mr-2 cursor-pointer flex",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteTrackedTime(
                                                              time.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "TimeTrackingDelete"
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                time.status.toLowerCase() ===
                                                "rejected"
                                                  ? _c("span", {
                                                      staticClass:
                                                        "cursor-pointer flex",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "openDeclineReasonModal",
                                                            time
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "textBlue" }, [
                                _vm._v(
                                  " Total Hours Tracked " +
                                    _vm._s(
                                      _vm.convertSecondsToReadable(
                                        _vm.timeAggregate
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }